import { defineAsyncComponent } from 'vue';
export default {
    data: () => ({
        // Contact
        contactdata: {},
        contactsdata: [],
        contactspayload: {},
        contactslastpayload: {},
        //Profile
        profilesData: [],
        profilesPayload: {},
        // Role
        roleapi: "addressbook/role/",
        roledata: {},
        rolesdata: [],
        rolespayload: {},
        roleslastpayload: {},
        // Participations
        participationapi: "addressbook/participation/",
        participationdata: {},
        participationsdata: [],
        participationpayload: {},
        participationslastpayload: {},
    }),
    props: {
        isProfile: { type: Boolean, default: false, },
        // Role
        role: { type: [Object, String,], },
        roles: { type: Array, default: [],},
        // Contact
        contact: { type: [Object, String,], },
        contacts: { type: Array, default: [],},
        // Participation
        participation: { type: [Object, String,], },
        participations: { type: Array, default: [], },
        // Profile
        profile: { type: [Object, String,], },
        profiles: { type: Array, default: [], },
    },
    components: {
        OctoloRole: defineAsyncComponent(() => import('@/octolo/addressbook/items/Role.vue')),
        OctoloContact: defineAsyncComponent(() => import('@/octolo/addressbook/items/Contact.vue')),
        ContactCardV2: defineAsyncComponent(() => import('@/octolo/addressbook/components/ContactCardV2.vue')),
        OctoloParticipation: defineAsyncComponent(() => import('@/octolo/addressbook/components/Participations.vue')),
    },
    computed: {
        // Contact
        contact_oneormany() { return this.contact ? [this.contact] : this.contacts; },
        contactdata_oneormany() { return this.contactdata?.fullname ? [this.contactdata] : this.contactsdata; },
        contactapi() { return this.isProfile ? "addressbook/profiles/" : "addressbook/"; },
        contactsfilters() {
            let filters = [{ input: "checkbox", tristate: true, name: "is_disable", label: this.gettext("Désactivé") },];
            if (this.rolesdata.length) {
                filters.push({
                    input: "select",
                    name: "roles",
                    label: this.gettext("Roles"),
                    empty: this.gettext("Tous les rôles"),
                    options: this.rolesdata.map(role => ({ value: role.uid, label: role.name })),
                });
            }
            return filters
        },
        // Role
        role_oneormany() { return this.role ? [this.role] : this.roles; },
        roledata_oneormany() { return this.roledata?.name ? [this.roledata] : this.rolesdata; },
        //profile
        profile_oneormany() { return this.profiles.length ? this.profiles : this.profilesData; },
        // participation
        participation_oneormany() { return this.participation ? [this.participation] : this.participations; },
        participationdata_oneormany() { return this.participationdata?.name ? [this.participationdata] : this.participationsdata; },

    },
    methods: {
        // Contact
        syncContact(contact, reload=true) {
            return this.$api.get(this.urlApi(this.contactapi+contact+"/sync_contact_and_user/")).then(response => {
                if(reload)
                    this.reloadContact(response.data);
            });
        },
        loadContact(contact){ return this.$api.get(this.urlApi(this.contactapi+contact+"/")); },
        loadContacts(params){ return this.$api.get(this.urlApi(this.contactapi), {params}); },
        reloadContact(contact) {
            let idx = this.contactsdata.results.findIndex(c => c.uid === contact.uid);
            if (idx !== -1) {
                this.contactsdata.results[idx] = contact;
            }
        },
        getContact(contact){ this.loadContact(contact).then(response => { this.contactdata = response.data; }); },
        getContacts(params){
            let payload =  params && Object.keys(params).length ? params : this.contactspayload;
            this.loadContacts(payload).then(response => { this.contactsdata = response.data; });
        },
        searchContact(payload, pltokeep) {
            this.put_on_hold(() => {
                let params = payload;
                if (pltokeep) { params = { ...pltokeep, ...params }; }
                this.contactslastpayload = params;
                this.call_api_data({
                    url: this.contactapi,
                    payload: { params },
                    cancelid: "searchContact",
                }).then(response => {
                    this.contactsdata = response.data;
                });
            }, 300,);
        },
        updateContact(contact, payload) {
            this.put_on_hold(() => {
                this.call_api_data({
                    url: this.contactapi + contact + "/",
                    method: "put",
                    payload,
                }).then(response => {
                    this.reloadContact(response.data);
                });
            }, 300,);
        },
        // Contact Profile
        getProfiles(params) {
            return this.$api.get(this.urlApi(this.contactapi), { params });
        },
        loadProfiles(params) {
            let payload = params && Object.keys(params).length ? params : this.profilesPayload;
            this.getProfiles(payload).then(response => {
                this.profilesData = response.data;
            }).catch(error => {
                console.error("Erreur lors de la récupération des profils :", error);
            });
        },
        searchProfiles(search) {
            this.put_on_hold(() => {
                this.call_api_data({
                    url: this.contactapi,
                    payload: { params :  search  },
                    cancelid: "searchContactProfiles",
                }).then(response => {
                    this.profilesData = response.data;
                });
            }, 300,);
        },
        // Role
        loadRole(role){ return this.$api.get(this.urlApi(this.roleapi+role+"/")); },
        loadRoles(params){ return this.$api.get(this.urlApi(this.roleapi), { params }); },
        getRole(role){ this.loadRole(role).then(response => { this.roledata = response.data; }); },
        getRoles(params){
            let payload = params && Object.keys(params).length ? params : this.rolespayload;
            this.loadRoles(payload).then(response => { this.rolesdata = response.data; });
        },
        // Participation
        loadParticipation(participation){ return this.$api.get(this.urlApi(this.participationapi+participation+"/")); },
        loadParticipations(params){ return this.$api.get(this.urlApi(this.participationapi), { params }); },
        getParticipation(participation){ this.loadParticipation(participation).then(response => { this.participationdata = response.data; }); },
        getParticipations(params){
            let payload = params && Object.keys(params).length ? params : this.participationpayload;
            this.loadParticipations(payload).then(response => { this.participationsdata = response.data; });
        },
        searchParticipation(payload, pltokeep) {
            this.put_on_hold(() => {
                let params = payload;
                if (pltokeep) { params = { ...pltokeep, ...params }; }
                this.participationslastpayload = params;
                this.call_api_data({
                    url: this.participationapi,
                    payload: { params },
                    cancelid: "searchParticipations",
                }).then(response => {
                    this.participationsdata = response.data;
                });
            }, 300,);
        }
    }
}
